import { color } from '@nuvolo/nuux-theme/utils';
import styled from 'styled-components';
import { ACTIVE_COLOR } from './Styles';

const MobileActiveMarker = styled.div`
  position: absolute;
  top: -11px;
  width: 50px;
  height: 0px;
  border-bottom: 4px solid ${ACTIVE_COLOR};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export default MobileActiveMarker;
